import React, { createContext, useContext, useEffect } from 'react';
import { ThemeProvider, type Theme } from '@mui/material/styles';

/**
 * The theme the cashier POS screens have always used (classic scheme, or the company's Full
 * Modern look). The back office gets the "new look" layer (theme/newLook.ts); the cashier
 * screens — sale, touch terminal, sale return, exchange — stay exactly as they were.
 */
export const LegacyThemeContext = createContext<Theme | null>(null);

/** Wrap a cashier POS screen so it keeps its original theme (and page background). */
export const PosThemeScope: React.FC = ({ children }) => {
  const legacy = useContext(LegacyThemeContext);

  // The body colour comes from the app theme; give the POS its own back while it is open.
  useEffect(() => {
    if (!legacy) return undefined;
    const previous = document.body.style.backgroundColor;
    const bg = legacy.palette.background.default;
    document.body.style.backgroundColor = bg === 'transparent' ? '' : String(bg);
    return () => {
      document.body.style.backgroundColor = previous;
    };
  }, [legacy]);

  if (!legacy) return <>{children}</>;
  return <ThemeProvider theme={legacy}>{children}</ThemeProvider>;
};

export default PosThemeScope;
